import 'moment/locale/de';
import 'moment/locale/fr';
import moment from 'moment';
import React, { PropsWithChildren } from 'react';
import { RawIntlProvider } from 'react-intl';
import { intl } from '../../intl';

// this only works with the `en`, `de`, and `fr` locales.
// we have to import (see top of this file) every locale that we support 🥴
moment.locale('en');
moment.locale(intl.locale);

/** `IntlProviderProps` is used to set properties on `IntlProvider`. */
interface IntlProviderProps {}

/** `IntlProvider` is used as a wrapper to provide subtree components with data
 * required for string internationalization. */
export const IntlProvider: React.FC<PropsWithChildren<IntlProviderProps>> = ({ children }) => (
  <RawIntlProvider value={intl}>{children}</RawIntlProvider>
);
